var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrustShield3 = function SvgIconTrustShield3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.999,
    d: "m8.997 10.996 3 3 9.996-9.997m-1 7.997v6.998a2 2 0 0 1-2 2H4.999a2 2 0 0 1-1.999-2V4.998a2 2 0 0 1 2-1.999h10.996"
  })));
};
export default SvgIconTrustShield3;